import { ReactNode } from 'react';

// The landing page has its own unique layout (full width, no app shell)
// So we just return the children directly or wrap in a simple div if needed.
// The spec says AppLayout is NOT for the landing page.

const LandingLayout = ({ children }: { children: ReactNode }) => {
  return <>{children}</>;
};

export default [LandingLayout];
